import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  FormGroup,
  Form,
  Input,
  CardFooter
} from "reactstrap";
import axios from "axios";
import Constants from "variables/Constants";
import folder from "../assets/img/folder.png";
import Modal from "react-awesome-modal";
import Notification from "components/Notification.jsx";
import Loader from "components/Loader.jsx";
import { Redirect, Link } from "react-router-dom";
class UpdateBatch extends Component {
  state = {
    name: "",
    date: "",
    batch_time: "",
    course_id: 0,
    media: [],
    levels: [],
    level: "",
    file: "",
    courses: [],
    description: "",
    redirect: false,
    notification: false,
    imgUpdated: false,
    loading: false,
    modal: true,
    parsedImgArray: [],
    images: false,
    border: false
  };
  handleInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  componentDidMount() {
    const ageGroupData = this.props.location.state.ageGroupData;
    console.log(ageGroupData);
    this.setState({
      name: ageGroupData.name,
      file: ageGroupData.file,
      description: ageGroupData.description,
      level: ageGroupData.label ? ageGroupData.label.id : "NA",
      course_id: ageGroupData.course_id,
      date: ageGroupData.start_date
        ? ageGroupData.start_date.slice(0, 10)
        : "NA",
      image: ageGroupData.image,
      batch_time: ageGroupData.batch_time ? ageGroupData.batch_time : "NA"
    });
    axios.get(Constants.getUrls.allCourses).then(resp => {
      console.log(resp.data);
      this.setState({
        courses: resp.data
      });
    });
    axios.get(Constants.getUrls.media).then(resp => {
      console.log(resp.data);
      this.setState({
        media: resp.data.data
      });
    });
    axios.get(Constants.getUrls.levels).then(resp => {
      console.log(resp.data);
      this.setState({
        levels: resp.data.data
      });
    });
  }
  openModal() {
    this.setState({
      visible: true,
      images: false,
      modal: true
    });
  }
  handleFile = e => {
    // let file = e.target.files[0];
    // let payLoad = {
    //   lastModified:file.lastModified,
    //   lastModifiedDate:file.lastModifiedDate,
    //   name:file.name.replace(/\s/g, ''),
    //   size:file.size,
    //   type:file.type,
    //   webkitRelativePath:file.webkitRelativePath,
    // }
    // console.log(payLoad);
    this.setState({ [e.target.name]:e.target.files[0],imgUpdated:true });
  };
  closeModal() {
    this.setState({
      visible: false
    });
  }
  handleFiles = (img, index) => {
    console.log(img);
    this.setState(
      {
        visible: false,
        image: img,
        active: index
      },
      () => {
        console.log(this.state.image);
      }
    );
  };
  handleFolder = id => {
    console.log(id);
    let filteredMedia = [];

    this.state.media.forEach(category => {
      if (id == category.id) {
        filteredMedia.push(category);
      }
    });
    console.log(filteredMedia);

    let parsedImgArray = JSON.parse(filteredMedia[0].image);
    console.log(parsedImgArray);
    this.setState({
      parsedImgArray,
      modal: false,
      images: true
    });
  };
  handleSubmit = e => {
    this.setState({
      loading: true
    });
    e.preventDefault();
let fd = new FormData();
fd.append("name", this.state.name);
    fd.append("description", this.state.description);
    fd.append("course_id", this.state.course_id);
    fd.append("image", this.state.image);
    fd.append("label_id", this.state.level);
    fd.append("start_date", this.state.date);
    fd.append("batch_time", this.state.batch_time);
    if (this.state.imgUpdated) {
    fd.append("file", this.state.file);
    }
    const ageGroupData = this.props.location.state.ageGroupData;
    const ageGroupId = parseInt(ageGroupData.id);

    axios.post(Constants.postUrls.updateBatch + ageGroupId, fd).then(resp => {
      console.log(resp);
      setTimeout(() => {
        this.setState({
          redirect: true
        });
      }, 1000);
      this.setState({
        notification: true,
        loading: false
      });
    });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/batches"} />;
    } else {
      return (
        <>
          <div className="content">
            {this.state.notification ? (
              <Notification title={"Batch Updated"} duration={3000} />
            ) : null}
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Update Batch</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        <Col className="pr-1" md="6">
                          <FormGroup>
                            <label>Name</label>
                            <Input
                              name="name"
                              value={this.state.name}
                              onChange={this.handleInput}
                              required={true}
                              placeholder="Name"
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="pr-1" md="6">
                          <FormGroup>
                            <label>Description</label>
                            <Input
                              name="description"
                              value={this.state.description}
                              onChange={this.handleInput}
                              placeholder="Description"
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pr-1" md="6">
                          <FormGroup>
                            <label>Course Select:</label>
                            <br />
                            <select
                              className="form-control"
                              required={true}
                              value={this.state.course_id}
                              name="course_id"
                              onChange={this.handleInput}
                            >
                              <option value="">Select an Option</option>
                              {this.state.courses.map((category, index) => (
                                <option value={category.id}>
                                  {category.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pr-1" md="6">
                          <FormGroup>
                            <label>Level Select:</label>
                            <br />
                            <select
                              className="form-control"
                              required={true}
                              value={this.state.level}
                              name="level"
                              onChange={this.handleInput}
                            >
                              <option value="">Select an Option</option>
                              {this.state.levels.map((category, index) => (
                                <option value={category.id}>
                                  {category.label}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pr-1" md="6">
                          <FormGroup>
                            <label>Date</label>
                            <Input
                              value={this.state.date}
                              placeholder="YYYY-MM-DD"
                              required={true}
                              name="date"
                              onChange={this.handleInput}
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pr-1" md="6">
                          <FormGroup>
                            <label>Batch Time</label>
                            <Input
                              placeholder="Batch Time"
                              required={true}
                              value={this.state.batch_time}
                              name="batch_time"
                              onChange={this.handleInput}
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="fileMarginBottom" md="6">
                          <label>Image</label>
                          <br />
                          <section>
                            <Button
                              onClick={() => this.openModal()}
                              color="primary"
                              type="button"
                            >
                              Add Image
                            </Button>
                          </section>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="fileMarginBottom" md="6">
                          <label>File</label>
                          <br />
                          <input
                            type="file"
                            name="file"
                            onChange={this.handleFile}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="fileMarginBottom" md="6">
                          <label>Selected Image</label>
                          <br />
                          <img
                            width="80px"
                            src={this.state.image}
                            alt=""
                            srcset=""
                          />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <div className="update ml-auto mr-auto">
                          <Button
                            className="btn-round"
                            color="primary"
                            type="submit"
                          >
                            {this.state.loading ? "Updating..." : "Update Batch"}
                          </Button>
                          <Link to="/admin/batches">
                            <Button className="btn-round" color="danger">
                              Cancel
                            </Button>
                          </Link>
                        </div>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Modal
              visible={this.state.visible}
              width="900"
              height="350"
              effect="fadeInUp"
              onClickAway={() => this.closeModal()}
            >
              {/* <Card> */}
              {/* <CardBody> */}
              {/* <Form onSubmit={this.variantSubmit}> */}
              <h3 style={{ marginLeft: "20px", marginTop: "20px" }}>
                Add Media
              </h3>
              <div
                style={{
                  overflowY: "scroll",
                  overflowX: "none",
                  height: "100%",
                  backgroundColor: "white"
                }}
              >
                <Row>
                  {this.state.modal
                    ? this.state.media.map((media, index) => (
                        <Col md="2">
                          <Card
                            className="card-stats"
                            onClick={() => {
                              this.handleFolder(media.id);
                            }}
                          >
                            <CardBody>
                              <Row>
                                <Col md="12" xs="5">
                                  <div className="icon-big text-center icon-warning">
                                    <img width="100px" src={folder} alt="" srcset="" />
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                            <CardFooter>
                              <hr />
                              <div className="stats">{media.name}</div>
                            </CardFooter>
                          </Card>
                        </Col>
                      ))
                    : null}
                  {this.state.images ? (
                    <div>
                      <Row>
                        {this.state.parsedImgArray.map((image, index) => {
                          return (
                            <Col md="2">
                              <img
                                src={Constants.imgUrl + image}
                                alt=""
                                width="90px"
                                name="image"
                                style={{
                                  marginLeft: "17px",
                                  border:
                                    this.state.active === index
                                      ? "2px solid black"
                                      : "2px solid #fff"
                                }}
                                onClick={() => {
                                  this.handleFiles(image, index);
                                }}
                              />
                            </Col>
                          );
                        })}
                      </Row>
                      {/* <Row>
                        <div className="update ml-auto mr-auto">
                          <Button
                            className="btn-round"
                            color="danger"
                            onClick={() => this.closeModal()}
                            style={{ position: "fixed", bottom: "-60px" }}
                          >
                            Close
                          </Button>
                        </div>
                      </Row> */}
                    </div>
                  ) : null}
                </Row>
                {/* </Form> */}
                {/* </CardBody> */}
                {/* </Card> */}
              </div>
            </Modal>
          </div>
        </>
      );
    }
  }
}

export default UpdateBatch;
